export function validateNativeLocation(location, maxAccuracyMeters = 100) {
  if (!location) return { ok: false, reason: "missing" };
  const lat = Number(location.latitude);
  const lng = Number(location.longitude);
  const accuracy = Number(location.accuracy);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) ||
      lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return { ok: false, reason: "invalid_coordinates" };
  }
  if (!Number.isFinite(accuracy) || accuracy < 0 || accuracy > maxAccuracyMeters) {
    return {
      ok: false,
      reason: "imprecise",
      accuracy: Number.isFinite(accuracy) ? accuracy : null,
    };
  }
  return { ok: true, lat, lng, accuracy };
}
